import { render, staticRenderFns } from "./FormFieldLabel.vue?vue&type=template&id=48ea9bb7&scoped=true&"
import script from "./FormFieldLabel.vue?vue&type=script&lang=js&"
export * from "./FormFieldLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldLabel.vue?vue&type=style&index=0&id=48ea9bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea9bb7",
  null
  
)

export default component.exports